// Module
var code = "<a ng-if=\"!match.model.id\"> {{ 'Gui.Common.CreateNew' | translate }} </a> <a ng-if=\"match.model.id\"> <span ng-bind-html=\"match.label | uibTypeaheadHighlight:query\"></span> </a>";
// Exports
var _module_exports = code;;
var path = '/App/Modules/Gui/Directives/Forms/InputTypeahead/InputTypeaheadResultTemplate.html';
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, _module_exports) }]);
module.exports = path;